(function () {
  async function insertSectionCartDrawer() {
  if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return
  var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
  if (!cartDrawerItems) return
  if (cartDrawerItems.classList.contains('is-empty')) return
  const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
  if (!upsells) return
  var wrapper = document.createElement('div')
  wrapper.classList.add('cart-drawer-items-wrapper')
  cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
  wrapper.appendChild(cartDrawerItems)
  wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)
  if (!document.querySelector('.cart-drawer-upsell-list li')) {
  var empty = document.querySelector('#cart-drawer-upsell')
  if (empty) empty.remove()
  }
  }
  insertSectionCartDrawer()
  window.onChangeKsUpsellVariantSelector = function (select, event) {
  event.preventDefault()
  const imgSrc = select.options[select.selectedIndex].dataset.variantImg
  if (imgSrc) {
  const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
  img.src = imgSrc
  }
  }
  // Correctif Nelia (octobre 2026) : avant, la moindre modification du tiroir panier
  // (compte a rebours, animations) relancait le telechargement complet de la page,
  // environ une fois par seconde sur toutes les pages du site.
  // Les suggestions ne sont plus rechargees que lorsque le contenu du panier change vraiment.
  function cartSignature() {
  var items = document.querySelector('#CartDrawer-CartItems')
  if (!items) return ''
  return Array.prototype.map.call(items.querySelectorAll('.quantity__input'), function (input) {
  return input.getAttribute('data-quantity-variant-id') + ':' + input.getAttribute('value')
  }).join('|')
  }
  function listenCartDrawer() {
  const element = document.querySelector('cart-drawer')
  if (!element) return
  let timer
  let loading = false
  let lastSignature = cartSignature()
  const observer = new MutationObserver(() => {
  if (timer) clearTimeout(timer)
  timer = setTimeout(async () => {
  const signature = cartSignature()
  if (signature === lastSignature || loading) {
  if (!document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) insertSectionCartDrawer()
  return
  }
  lastSignature = signature
  loading = true
  try {
  const response = await fetch(window.location.href)
  const text = await response.text()
  const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('#cart-drawer-upsell-wrapper')
  const current = document.querySelector('#cart-drawer-upsell-wrapper')
  if (fresh && current) current.replaceWith(fresh)
  insertSectionCartDrawer()
  } catch (e) {
  } finally {
  loading = false
  }
  }, 250)
  })
  observer.observe(element, { childList: true, subtree: true })
  }
  listenCartDrawer()
  })();
  